import { CpsUiAdminConfigType } from '@cs-cms/types';
import { UseQueryResult, useQuery } from '@tanstack/react-query';
import { useContext } from 'react';
import ServicesContext from '../../contexts/ServicesContext';
import { uiAdminConfigsKeys } from '../../queryKeys/uiAdminConfigs';

export function useGetUiAdminConfigEntry(key?: CpsUiAdminConfigType): UseQueryResult<string, unknown> {
  const servicesCtx = useContext(ServicesContext);

  const getUiAdminConfigEntry = () => {
    if (servicesCtx?.uiAdminConfigsService && key) {
      return servicesCtx.uiAdminConfigsService.getUiAdminConfigEntry(key);
    }
    throw new Error('Services context not initialized');
  };

  return useQuery({
    queryKey: uiAdminConfigsKeys.uiAdminConfigByKey(key),
    queryFn: getUiAdminConfigEntry,
    enabled: !!key,
    retry: 0,
    staleTime: Infinity,
    gcTime: 28800000
  });
}
